import * as yup from "yup";

const helpSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email("Valid email required")
    .required("Valid email required"),
  name: yup.string().required("Name required"),
  ticket: yup
    .string()
    .required("Description required"),
});

export default helpSchema;
